<template>
    <form-view class="schema-service-form-view" @submitsuccess="goToServiceList">
        <template slot="field">
            <veui-field label="应用名称："
                name="appId"
                field="appId"
                :readonly="!!store.createForFixedAppId || isDetail"
                :disabled="isEdit"
                rules="required">
                <search-select
                    :options="store.appDatasource"
                    v-model="store.formData.appId"
                    placeholder="请选择"/>
                    <veui-button v-if="isCreate" @click="goToCreateApp" ui="link">新建应用</veui-button>
            </veui-field>
           <veui-field label="服务名称："
                name="name"
                field="name"
                :readonly="isDetail"
                :disabled="!isEditDraft && !isCreate"
                :rules="validator('required|name|maxLength:20')"
                tip="最多可输入20个字符">
                <veui-input
                    v-model="store.formData.name"
                    placeholder="数字、字母、汉字"/>
            </veui-field>
            <template v-if="isDetail">
                <veui-field label="authKey：">
                    <veui-span>{{ authKey }}</veui-span>
                </veui-field>
                <veui-field label="activityId：">
                    <veui-span>{{ activityId }}</veui-span>
                </veui-field>
            </template>
            <veui-field label="数据接收邮箱："
                name="mailReceiver"
                field="mailReceiver"
                :readonly="isDetail"
                :rules="validator('multiEmail')">
                <veui-input
                    v-model="store.formData.mailReceiver"
                    placeholder="请输入邮箱，多个邮箱英文逗号分隔"/>
            </veui-field>
            <veui-field label="数据解压密码："
                name="zipPassword"
                field="zipPassword"
                :readonly="isDetail"
                :rules="store.formData.mailReceiver ? 'required' : ''">
                <veui-input
                    v-model="store.formData.zipPassword"/>
            </veui-field>
        </template>
        <template slot="operation">
            <template v-if="isCreate || isEditDraft">
                <veui-button ui="primary" type="submit"
                    @click="store.formData.submitType='publish'">提交发布</veui-button>
                <veui-button class="primary-border-btn"
                    type="submit"
                    @click="store.formData.submitType='save'">保存为草稿</veui-button>
            </template>
            <template v-else-if="isEdit">
                <veui-button ui="primary" type="submit" @click="store.formData.submitType='publish'">修改完成</veui-button>
            </template>
            <veui-button @click="goToServiceList">{{ cancelText }}</veui-button>
        </template>
    </form-view>
</template>

<script>
import FormView from '@baidu/ve-ria/views/FormView';
import FormModel from './FormModel';
import createView from '@baidu/ve-ria/views/createView';
import {Field, Button, Input, Span, Select, RadioGroup, Textarea} from 'veui';
import SearchSelect from '@/common/components/SearchSelect';
import serviceMixin from '@/common/mixins/service';

export default createView(FormView, FormModel, {
    name: 'SchemaServiceFormView',
    components: {
        'veui-field': Field,
        'veui-input': Input,
        'veui-span': Span,
        'veui-button': Button,
        'veui-select': Select,
        'veui-radio-group': RadioGroup,
        'veui-textarea': Textarea,
        SearchSelect
    },
    mixins: [serviceMixin]
});
</script>
